import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from "../../../../common/variables/translate-service";
import { ImagePathService } from "../../../../common/variables/image-path.service";
import { SC_Input } from "../../../../common/input/SC_Input";
import { SC_Beam } from "../../../../common/roof/SC_Beam";
import { RoofShape } from '../../../../common/roof/RoofShape';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'sen-app-beam-distance-control',
  templateUrl: './beam-distance-control.component.html',
  styleUrls: ['./beam-distance-control.component.scss']
})
export class BeamDistanceControlComponent implements OnInit {
  @Output() emitbSuccess = new EventEmitter;
  @Input() beamType: string;

  distanceFirstElement: string = "rbDist1";
  distanceLastElement: string = "rbDist2";
  distanceRafter: string = "rbDist";
  numberOfRafter_Purlin: string = "rbAmount";
  rbAmount_selected: boolean = false;
  rbDist1_selected: boolean = true;


  nsAmount_value: number = SC_Input.iBeamAmount;
  nsDist_value: number = SC_Input.nBeamDist;
  nsDist1_value: number = SC_Input.nBeamDist1;
  nsDist2_value: number = SC_Input.nBeamDist2;
  selectedElement: string = this.distanceFirstElement;
  selectedR_P: string = this.distanceRafter;
  bSuccess: boolean = false;
  beamMinMax: any = SC_Input.beamMinMax;
  nsAmount_minimum: number;
  nsAmount_maximum: number;
  constructor(public translate: TranslateService, public imagePath: ImagePathService) { }

  ngOnInit(): void {
    SC_Input.nRoofRange = SC_Input.iBeamType == SC_Beam.PURLIN ? RoofShape.getCurrentRoofHeight() : RoofShape.getCurrentRoofWidth();
    this.nsDist_value = SC_Input.nBeamDist;
    this.nsDist1_value = SC_Input.nBeamDist1;
    this.nsAmount_value = Math.floor((SC_Input.nRoofRange - this.nsDist1_value) / this.nsDist_value) + 1;
    this.nsDist2_value = (SC_Input.nRoofRange - this.nsDist1_value) % this.nsDist_value;
    this.nsAmount_minimum = Math.floor((SC_Input.nRoofRange - (this.nsDist1_value + this.nsDist2_value)) / this.beamMinMax.nDistMax) + 1;
    this.nsAmount_maximum = Math.floor((SC_Input.nRoofRange - (this.nsDist1_value + this.nsDist2_value)) / this.beamMinMax.nDistMin) + 1;
    this.setRange();
  }

  nsDist_changeHandler(e: any): void {
    const value = parseInt(e.target.value);
    if (value >= this.beamMinMax.nDistMin && value <= this.beamMinMax.nDistMax) {
      let nRoofRange = SC_Input.nRoofRange;
      if (this.selectedElement == "rbDist1") {
        this.nsDist2_value = (nRoofRange - this.nsDist1_value) % value;
      } else {
        this.nsDist1_value = (nRoofRange - this.nsDist2_value) % value;
      }
      this.nsAmount_value = Math.floor((nRoofRange - this.nsDist1_value) / value) + 1;
      this.nsDist_value = value;
      this.setRange();
    } else {
      this.nsAmount_value = SC_Input.iBeamAmount;
      this.nsDist_value = SC_Input.nBeamDist;
    }
  }

  nsAmount_changeHandler(e: any): void {
    const value = parseInt(e.target.value);
    let nRoofRange = SC_Input.nRoofRange;
    const valueTemp = Math.floor((nRoofRange - (this.nsDist1_value + this.nsDist2_value)) / (value - 1));
    if (value >= this.nsAmount_minimum && value <= this.nsAmount_maximum) {
      this.nsAmount_value = value;
      if (this.beamMinMax.nDistMax >= valueTemp && this.beamMinMax.nDistMin <= valueTemp) {
        this.nsDist_value = valueTemp;
      } else {
        this.nsDist_value = this.beamMinMax.nDistMax >= valueTemp ? this.beamMinMax.nDistMin : this.beamMinMax.nDistMax;
      }
      if (this.selectedElement == "rbDist1") {
        this.nsDist2_value = (nRoofRange - this.nsDist1_value) % this.nsDist_value;
      } else {
        this.nsDist1_value = (nRoofRange - this.nsDist2_value) % this.nsDist_value;
      }
      this.setRange();
    } else {
      this.nsAmount_value = SC_Input.iBeamAmount;
      this.nsDist_value = SC_Input.nBeamDist;
    }
  }

  nsDist1_changeHandler(): void {

    let nRoofRange = SC_Input.nRoofRange;
    this.nsDist2_value = (nRoofRange - this.nsDist1_value) % this.nsDist_value;
    if (this.selectedR_P == "rbAmount") {
      this.nsDist_value = Math.floor((nRoofRange - (this.nsDist1_value + this.nsDist2_value)) / (this.nsAmount_value - 1));
    } else {
      this.nsAmount_value = Math.floor((nRoofRange - (this.nsDist1_value + this.nsDist2_value)) / this.nsDist_value) + 1;
    }
    this.setRange();
  }

  nsDist2_changeHandler(): void {
    let nRoofRange = SC_Input.nRoofRange;
    this.nsDist1_value = (nRoofRange - this.nsDist2_value) % this.nsDist_value;
    if (this.selectedR_P == "rbAmount") {
      this.nsDist_value = Math.floor((nRoofRange - (this.nsDist1_value + this.nsDist2_value)) / (this.nsAmount_value - 1));
    } else {
      this.nsAmount_value = Math.floor((nRoofRange - (this.nsDist1_value + this.nsDist2_value)) / this.nsDist_value) + 1;
    }
    this.setRange();
  }

  setRange() {
    SC_Input.isPlanAltered = true;
    SC_Input.nBeamDist = this.nsDist_value;
    SC_Input.nBeamDist1 = this.nsDist1_value;
    SC_Input.nBeamDist2 = this.nsDist2_value;
    SC_Input.iBeamAmount = this.nsAmount_value;
    SC_Input.updatedBeamInput = true;
    if (this.nsDist2_value >= this.nsDist_value) {
      this.bSuccess = true;
    } else {
      this.bSuccess = false;
    }
    this.emitbSuccess.emit(this.bSuccess);
    SC_Beam.drawBeam(null);
    SC_Beam.layerBeam.draw();
    // this.nsAmount_minimum = Math.floor((SC_Input.nRoofRange - (this.nsDist1_value + this.nsDist2_value)) / this.beamMinMax.nDistMax) + 1;
    // this.nsAmount_maximum = Math.floor((SC_Input.nRoofRange - (this.nsDist1_value + this.nsDist2_value)) / this.beamMinMax.nDistMin) + 1;
  }
}
